<template>
  <popup
    :opened="dataToShow > -1"
    @close="changeToShow(-1)"
  >
    <!-- BEGIN STEP 1 : Content modal add new file -->
    <div
      v-if="dataToShow == 1"
      v-cloak
      @drop.prevent="addTempFile"
      @dragover.prevent
    >
      <div class="my-5 mx-5 md:mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32">
        <h3 class="mb-10">
          Ajouter un nouveau fichier
        </h3>
        <div
          class="bg-indigo-100 rounded-lg flex flex-col items-center space-y-3 py-24"
        >
          <icon
            name="file"
            class="text-pink-600 w-12 h-12"
            :class="{ 'animate-pulse': loading }"
          />
          <div
            v-if="!loading"
            class="flex flex-col items-center space-y-3"
          >
            <h3 class="text-indigo-600">
              Glissez & Déposez
            </h3>
            <h6 class="text-gray-600">
              ou
              <input
                type="file"
                id="upload-file"
                class="hidden"
                @change="addTempFile"
              ><label
                for="upload-file"
                class="underline cursor-pointer"
              >sélectionnez</label>
              votre document
            </h6>
            <div class="text-red-500 text-sm">
              {{ ((errors || []).file || [])[0] }}
            </div>
            <div class="text-red-500 text-sm">
              {{ ((errors || []).forbidden || [])[0] }}
            </div>
          </div>
          <div v-if="loading">
            <h6 class="text-gray-600 animate-pulse">
              Fichier en cours d'envoi...
            </h6>

            <div
              v-if="uploading"
              class="w-full mt-2 bg-gray-500 rounded-full"
            >
              <div
                class="bg-teal-600 text-md text-center p-0.5 leading-none rounded-full"
                :style="`width: ${uploadProgress}%`"
              >
                {{ uploadProgress }}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END STEP 1 : Content modal add file -->

    <!-- BEGIN STEP 2 : edit new file informations -->
    <div v-else-if="dataToShow == 2">
      <div class="my-5 lg:my-15 2xl:my-20 mx-16 2xl:mx-24">
        <h3 class="mb-10">
          Ajouter un nouveau fichier
        </h3>
        <div
          class="flex flex-col justify-center space-y-5 items-center md:flex-row md:justify-start md:space-x-10 md:space-y-0"
        >
          <img
            v-if="constants.FILE_TYPES.img.includes(filetype.toLowerCase())"
            :src="'/' + fileTemp.path"
            class="object-cover w-64 h-64 2xl:w-80 2xl:h-80 rounded-md border border-indigo-300"
          >
          <embed
            v-else-if="
              constants.FILE_TYPES.pdf.includes(filetype.toLowerCase())
            "
            :src="'/' + fileTemp.path + '#toolbar=0&navpanes=0'"
            class="w-64 h-64 2xl:w-80 2xl:h-80 rounded-md border border-indigo-300"
          >
          <div
            v-else-if="
              constants.FILE_TYPES.doc.includes(filetype.toLowerCase())
            "
            class="flex items-center justify-center w-64 h-64 2xl:w-80 2xl:h-80 rounded-md bg-gray-200 border border-indigo-300"
          >
            <icon
              name="file"
              class="text-blue-600 transform scale-150"
            />
          </div>
          <div
            v-else-if="
              constants.FILE_TYPES.xls.includes(filetype.toLowerCase())
            "
            class="flex items-center justify-center w-64 h-64 2xl:w-80 2xl:h-80 rounded-md bg-gray-200 border border-indigo-300"
          >
            <icon
              name="file"
              class="text-green-600 transform scale-150"
            />
          </div>
          <div
            v-else
            class="flex items-center justify-center w-64 h-64 2xl:w-80 2xl:h-80 rounded-md bg-gray-200 border border-indigo-300"
          >
            <icon
              name="file"
              class="text-gray-900 transform scale-150"
            />
          </div>

          <div class="grid grid-cols-4 items-center md:gap-10 w-full">
            <div class="col-span-1">
              Nom
            </div>
            <input-text
              class="lg:col-span-3"
              name="nom"
              :value="filename"
              @input="
                (newValue) => {
                  filename = newValue;
                }
              "
              :maxlength="40"
              :error="true"
            />
            <div class="col-span-full h-10 md:hidden" />
            <div class="col-span-1">
              Emplacement
            </div>
            <search-bar
              name="searchFolder"
              :has-border="true"
              icon="chevron-down"
              icon-color="text-pink-600"
              placeholder="Définir l'emplacement"
              :value="searchFolder"
              :has-suggestion="true"
              @input="
                (newValue) => {
                  searchFolder = newValue;
                }
              "
              @displaySuggestionsList="
                (state) => {
                  displaySuggestionsFoldersList(state);
                }
              "
              class="lg:col-span-3"
            >
              <template
                v-if="isFoldersListDisplayed"
                #suggestionsList
              >
                <div
                  class="h-20 border-b border-indigo-600 grid grid-cols-12 gap-x-3 items-center px-6"
                >
                  <div class="col-span-2 cursor-pointer">
                    <div
                      v-show="currentFolderInFolderSelection != null"
                      @click.stop="returnBack"
                    >
                      <icon
                        name="arrow-circle-left"
                        class="text-indigo-600 h-5 w-5"
                      />
                    </div>
                  </div>
                  <h5 class="col-span-10 text-left">
                    Dossiers
                  </h5>
                </div>
                <div
                  v-if="currentFolderInFolderSelection == null"
                  class="h-20 cursor-default grid grid-cols-12 items-center gap-x-3 px-6 bg-white bg-opacity-0 odd:bg-gray-200 odd:bg-opacity-50 hover:bg-indigo-200 hover:bg-opacity-100 odd:hover:bg-indigo-200 odd:hover:bg-opacity-100"
                  @click.stop="
                    selectFolder({
                      id: null,
                      name: 'Dépôt de documents',
                    })
                  "
                >
                  <icon
                    name="folder"
                    class="col-span-2 h-6 w-7 text-gray-600"
                  />
                  <div class="col-span-10 flex items-center space-x-3 ml-2 md:ml-0">
                    <p class="text-lg">
                      Mon dépôt de documents
                    </p>
                  </div>
                </div>
                <div
                  v-for="(folder, kf) in foldersFilter.filter(
                    (f) => f.folder_id == currentFolderInFolderSelection
                  )"
                  :key="kf"
                  class="h-20 cursor-default grid grid-cols-12 items-center gap-x-3 px-6 bg-white bg-opacity-0 odd:bg-gray-200 odd:bg-opacity-50 hover:bg-indigo-200 hover:bg-opacity-100 odd:hover:bg-indigo-200 odd:hover:bg-opacity-100"
                  @click.stop="selectFolder(folder)"
                >
                  <icon
                    name="folder"
                    class="col-span-2 h-6 w-7"
                    :class="{
                      'text-indigo-600': folder.color == 'indigo',
                      'text-teal-600': folder.color == 'teal',
                      'text-orange-600': folder.color == 'orange',
                      'text-pink-600': folder.color == 'pink',
                      'text-gray-600': folder.color == 'gray',
                    }"
                  />
                  <div class="col-span-10 flex items-center space-x-3 ml-2 md:ml-0">
                    <p class="text-lg">
                      {{ folder.name }}
                    </p>
                    <p
                      class="text-base font-light italic text-gray-600"
                      v-show="
                        folders.filter((f) => f.folder_id == folder.id).length >
                          0
                      "
                    >
                      {{
                        folders.filter((f) => f.folder_id == folder.id).length
                      }}
                      Dossier{{
                        folders.filter((f) => f.folder_id == folder.id).length >
                          1
                          ? 's'
                          : ''
                      }}
                    </p>
                    <div class="flex-grow" />
                    <div
                      class="cursor-pointer"
                      v-show="
                        folders.filter((f) => f.folder_id == folder.id).length
                      "
                      @click.stop="currentFolderInFolderSelection = folder.id"
                    >
                      <icon
                        name="chevron-right"
                        class="text-pink-600 transform duration-300 hover:scale-125"
                      />
                    </div>
                  </div>
                </div>
              </template>
            </search-bar>

            <div
              v-if="false"
              class="col-span-full grid grid-cols-4 items-center gap-10 w-full"
            >
              <div class="col-span-1">
                Partage
              </div>
              <div class="lg:col-span-3 flex justify-center space-x-5 mt-10">
                <search-bar
                  name="share"
                  libelle="Partager"
                  :value="search"
                  placeholder="Ajouter des personnes ou des groupes"
                  :big="false"
                  :inherits="false"
                  :has-border="true"
                  :has-suggestion="true"
                  @input="
                    (newValue) => {
                      search = newValue;
                    }
                  "
                  @displaySuggestionsList="
                    (state) => {
                      displaySuggestionsList(state);
                    }
                  "
                >
                  <template
                    v-if="isSuggestionsListDisplayed"
                    #suggestionsList
                  >
                    <div
                      v-for="(member, memberIndex) in membersFilterSearch"
                      :key="memberIndex"
                      class="h-20 cursor-default grid grid-cols-12 items-center bg-white bg-opacity-0 odd:bg-gray-200 odd:bg-opacity-50 hover:bg-indigo-200 hover:bg-opacity-100 odd:hover:bg-indigo-200 odd:hover:bg-opacity-100"
                      @click.stop="selectMember(member)"
                    >
                      <div class="col-span-2 place-self-center">
                        <div class="h-full w-full px-2">
                          <ProfilePicture
                            size="max-w-12 w-12 h-12"
                            :other-object="member"
                          />
                        </div>
                      </div>
                      <div
                        v-if="member.username"
                        class="grid grid-cols-12 gap-x-4 col-span-10 text-left ml-4"
                      >
                        <div
                          class="grid-cols-12 gap-x-4"
                          :class="{
                            'col-span-6': !memberHasAccessToDepotDoc(member),
                            'col-span-full': memberHasAccessToDepotDoc(member),
                          }"
                        >
                          <div
                            class="text-lg font-normal col-span-full truncate"
                          >
                            <span class="userFirstNameDiv">{{
                              member.firstname + ' '
                            }}</span>
                            <span class="uppercase userLastNameDiv">{{
                              member.lastname
                            }}</span>
                          </div>

                          <div class="col-span-full text-sm text-gray-600">
                            {{ mainRole(member).display_name }}
                          </div>
                        </div>
                        <span
                          v-if="
                            memberIsBeneficiary(member) &&
                              !memberHasAccessToDepotDoc(member)
                          "
                          class="col-span-6 my-auto text-pink-600 text-2sm italic font-light"
                        >
                          Cet utilisateur n'a pas accès au module dépôt de
                          documents
                        </span>
                        <span
                          v-else-if="!memberHasAccessToDepotDoc(member)"
                          class="col-span-6 my-auto text-pink-600 text-2sm italic font-light"
                        >
                          Le rôle «{{ mainRole(member).display_name }}» n'a pas
                          accès au module dépôt de documents
                        </span>
                      </div>
                      <div
                        v-else
                        class="grid grid-cols-12 gap-x-4 col-span-10 text-left ml-4"
                      >
                        <div
                          class="grid-cols-12 gap-x-4 col-span-6"
                          :class="{
                            'col-span-6': !roleHasAccessToDepotDoc(member),
                            'col-span-full': roleHasAccessToDepotDoc(member),
                          }"
                        >
                          <div
                            class="text-lg font-normal col-span-full truncate roleNameDiv"
                          >
                            {{ member.display_name }}
                          </div>
                          <div
                            v-if="member.company_id == null"
                            class="col-span-full text-sm text-gray-600"
                          >
                            Role par défaut
                          </div>
                        </div>
                        <span
                          v-if="!roleHasAccessToDepotDoc(member)"
                          class="col-span-6 my-auto text-pink-600 text-2sm italic font-light"
                        >
                          Ce rôle n'a pas accès au module dépôt de documents
                        </span>
                      </div>
                    </div>
                  </template>
                </search-bar>
              </div>
              <div class="col-span-1" />
              <div class="lg:col-span-3 flex justify-center space-x-5">
                <div
                  v-if="selectedMembersFlat.length > 0"
                  class="flex flex-row flex-wrap items-center justify-start h-full gap-2 max-h-36 p-1 rounded-md border-indigo-600 border w-full border-opacity-50 overflow-y-scroll"
                >
                  <div
                    v-for="(selected, selectedIndex) in selectedMembersFlat"
                    :key="selectedIndex"
                  >
                    <tag
                      v-if="selected.username"
                      :libelle="
                        selected.firstname +
                          ' ' +
                          selected.lastname.toUpperCase()
                      "
                      :theme-color="roleColor(selected)"
                      :is-closeable="true"
                      @close="deselectMember(true, selectedIndex)"
                    />
                    <tag
                      v-else
                      :libelle="selected.display_name"
                      :theme-color="roleColor(selected)"
                      :is-closeable="true"
                      @close="deselectMember(false, selectedIndex)"
                    />
                  </div>
                </div>
              </div>
              <div class="col-span-1" />
              <div class="lg:col-span-3 grid grid-cols-12 gap-x-4 items-end">
                <div
                  class="col-span-9"
                  v-if="selectedMembersFlat.length > 0"
                >
                  <input-select
                    :libelle="'Droits d\'accès'"
                    name="access_rights"
                    value="Lecteur"
                    :datas="[
                      { value: 'Administrateur' },
                      { value: 'Editeur' },
                      { value: 'Lecteur' },
                    ]"
                    @input="
                      (newValue) => {
                        accessRights = newValue;
                      }
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col items-center mt-5">
          <div class="text-red-500 text-sm my-5">
            {{ ((errors || []).forbidden || [])[0] }}
          </div>
          <action-button
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            libelle="Ajouter"
            :uppercase="true"
            type-shadow="shadow-pink"
            icon="arrow-right_1"
            :right="true"
            @clickAction="addFile"
          />
        </div>
      </div>
    </div>
    <!-- END STEP 2 : edit new file informations -->
  </popup>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Popup from './../../../components/Popup';
import Icon from './../../../components/Icon';
import Illustration from './../../../components/Illustration';
import ActionButton from './../../../components/ActionButton';
import InputText from './../../../components/Inputs/InputText';
import InputSelect from './../../../components/Inputs/InputSelect';
import SearchBar from '../../../components/Inputs/SearchBar.vue';
import Constants from './../../../constants';
import store from '../../../store';
import Tag from '../../../components/Tag';
import ProfilePicture from './../../../components/ProfilePicture.vue';

export default {
  name: 'AddNewFilePopup',

  props: {
    dataToShow: Number,
    fileTemp: Object,
    currentFolder: {
      type: Number,
      required: false,
      default: null,
    },
    errors: {
      type: Object,
      required: false,
      default: {},
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      constants: Constants,
      tooMuchFiles: false,
      file: null,
      filename: '',
      extension: '',

      isFoldersListDisplayed: false,
      searchFolder: '',
      selectedFolder: null,
      currentFolderInFolderSelection: null,

      sharedWith: [],
      search: '',
      isSuggestionsListDisplayed: false,
      selectedMembers: { users: [], roles: [] },
      accessRights: '',
    };
  },

  components: {
    Popup,
    Icon,
    Illustration,
    ActionButton,
    InputText,
    InputSelect,
    SearchBar,
    Tag,
    ProfilePicture,
  },

  mounted() {
    store.dispatch('depotDocuments/loadAllMembers');
  },

  computed: {
    ...mapGetters({
      folders: 'depotDocuments/folders',
      allMembers: 'depotDocuments/allMembers',
      uploading: 'depotDocuments/uploading',
      uploadProgress: 'depotDocuments/uploadProgressPercent',
    }),

    foldersFilter: {
      get: function () {
        return [...this.folders].filter((f) =>
          f.name
            .toLocaleLowerCase()
            .includes(this.searchFolder.toLocaleLowerCase())
        );
      },
    },

    filetype: {
      get: function () {
        let name = this.file.name.split('.');

        return this.file ? name[name.length - 1] : '';
      },
    },

    membersFilter() {
      let allUsers = this.allMembers.users,
        allRoles = this.allMembers.roles,
        filteredUsers = [],
        filteredRoles = [];

      filteredUsers = allUsers.filter((user) => {
        if (
          this.folders
            .filter((f) => f.id == this.selectedFolder)[0]
            .users.some((u) => u.id == user.id) ||
          this.selectedMembers.users.some((u) => u.id == user.id)
        ) {
          return false;
        }
        return true;
      });

      filteredRoles = allRoles.filter((role) => {
        if (role.id == 1 || role.id == 7) {
          return false;
        }
        if (
          this.folders
            .filter((f) => f.id == this.selectedFolder)[0]
            .roles.some((r) => r.id == role.id) ||
          this.selectedMembers.roles.some((r) => r.id == role.id)
        ) {
          return false;
        }
        return true;
      });

      return {
        filteredUsers: filteredUsers,
        filteredRoles: filteredRoles,
      };
    },

    membersFilterSearch: {
      get: function () {
        let filteredUsersResult = [],
          filteredRolesResult = [],
          sortedUsersResult = [],
          sortedRolesResult = [];

        filteredUsersResult = this.membersFilter.filteredUsers.filter(
          (user) =>
            user.firstname
              .toLocaleLowerCase()
              .includes(this.search.toLocaleLowerCase()) ||
            user.lastname
              .toLocaleLowerCase()
              .includes(this.search.toLocaleLowerCase()) ||
            (
              user.firstname.toLocaleLowerCase() +
              ' ' +
              user.lastname.toLocaleLowerCase()
            ).includes(this.search.toLocaleLowerCase()) ||
            (
              user.lastname.toLocaleLowerCase() +
              ' ' +
              user.firstname.toLocaleLowerCase()
            ).includes(this.search.toLocaleLowerCase())
        );

        filteredRolesResult = this.membersFilter.filteredRoles.filter((role) =>
          role.display_name.toLowerCase().includes(this.search.toLowerCase())
        );

        sortedUsersResult = [...filteredUsersResult].sort(function (a, b) {
          let nameA = a.lastname.toUpperCase(),
            nameB = b.lastname.toUpperCase();
          return nameA.localeCompare(nameB);
        });

        sortedRolesResult = [...filteredRolesResult].sort(function (a, b) {
          let nameA = a.display_name.toUpperCase(),
            nameB = b.display_name.toUpperCase();
          return nameA.localeCompare(nameB);
        });

        return sortedUsersResult.concat(sortedRolesResult);
      },
    },

    selectedMembersFlat: {
      get: function () {
        return Object.values(this.selectedMembers).flat();
      },
    },
  },

  methods: {
    ...mapActions({
      //
    }),

    ...mapMutations({
      //
    }),

    selectMember(member) {
      if (member.username) {
        if (this.selectedMembers.users.some((user) => user.id == member.id)) {
          console.error('User already selected');
          return;
        }
        this.selectedMembers.users.push(member);
        this.displaySuggestionsList(false);
        this.search = '';
        return;
      }

      if (this.selectedMembers.roles.some((role) => role.id == member.id)) {
        console.error('Role already selected');
        return;
      }
      this.selectedMembers.roles.push(member);
      this.displaySuggestionsList(false);
      this.search = '';
    },

    deselectMember(user, index) {
      if (user) {
        this.selectedMembers.users.splice(index, 1);
        return;
      }
      this.selectedMembers.roles.splice(index, 1);
    },

    roleColor(member) {
      const Admin = 'teal';
      const Referent = 'indigo';
      const Beneficiary = 'pink';

      if (member.username) {
        switch (member.roles.filter((role) => role.company_id == null)[0].id) {
        case 2:
          return Admin;
        case 3:
          return Admin;
        case 4:
          return Referent;
        case 5:
          return Referent;
        case 6:
          return Beneficiary;
        default:
          return '';
        }
      }
      switch (member.id) {
      case 2:
        return Admin;
      case 3:
        return Admin;
      case 4:
        return Referent;
      case 5:
        return Referent;
      case 6:
        return Beneficiary;
      default:
        return '';
      }
    },

    displaySuggestionsList(state) {
      this.isSuggestionsListDisplayed = state;
    },

    changeToShow(val) {
      this.$emit('showChange', val);

      if (val == 2 && this.currentFolder) {
        this.selectFolder(
          this.folders.filter((f) => f.id == this.currentFolder)[0]
        );
      }
    },

    addTempFile(e) {
      let files = e.target.files || e.dataTransfer.files;

      if (files.length == 1) {
        //Store the file locally
        this.file = files[0];

        //Creating the request object
        let formData = new FormData();

        //according to file extension, chose if it is an image or other file
        if (
          Constants.FILE_TYPES.img.includes(
            this.file.name
              .substring(this.file.name.lastIndexOf('.') + 1)
              .toLowerCase()
          )
        ) {
          formData.append('image', this.file);
        }
        if (
          !Constants.FILE_TYPES.img.includes(
            this.file.name
              .substring(this.file.name.lastIndexOf('.') + 1)
              .toLowerCase()
          )
        ) {
          formData.append('file', this.file);
        }

        this.$emit('addTempFile', formData);

        this.filename = this.file.name
          .substring(0, this.file.name.lastIndexOf('.'))
          .substring(0, 40);
        this.extension = this.file.name.substring(
          this.file.name.lastIndexOf('.')
        );
      } else {
        // Don't allow add many pics in same time
        this.tooMuchFiles = true;
      }
    },

    addFile() {
      let usersWithRights = [];
      let rolesWithRights = [];

      if (this.selectedMembersFlat.length > 0) {
        if (this.selectedMembers.users.length > 0) {
          this.selectedMembers.users.forEach((user) => {
            let userWithRights = {};
            switch (this.accessRights) {
            case 'Administrateur':
              userWithRights = {
                user: user.id,
                rights: Constants.FILE_RIGHTS.ADMIN_RIGHTS,
              };
              break;
            case 'Editeur':
              userWithRights = {
                user: user.id,
                rights: Constants.FILE_RIGHTS.EDIT_RIGHTS,
              };
              break;
            case 'Lecteur':
              userWithRights = {
                user: user.id,
                rights: Constants.FILE_RIGHTS.READ_RIGHTS,
              };
              break;
            default:
              userWithRights = {
                user: user.id,
                rights: Constants.FILE_RIGHTS.READ_RIGHTS,
              };
              break;
            }
            usersWithRights.push(userWithRights);
          });
        }

        if (this.selectedMembers.roles.length > 0) {
          this.selectedMembers.roles.forEach((role) => {
            let roleWithRights = {};
            switch (this.accessRights) {
            case 'Administrateur':
              roleWithRights = {
                role: role.id,
                rights: Constants.FILE_RIGHTS.ADMIN_RIGHTS,
              };
              break;
            case 'Editeur':
              roleWithRights = {
                role: role.id,
                rights: Constants.FILE_RIGHTS.EDIT_RIGHTS,
              };
              break;
            case 'Lecteur':
              roleWithRights = {
                role: role.id,
                rights: Constants.FILE_RIGHTS.READ_RIGHTS,
              };
              break;
            default:
              roleWithRights = {
                role: role.id,
                rights: Constants.FILE_RIGHTS.READ_RIGHTS,
              };
              break;
            }
            rolesWithRights.push(roleWithRights);
          });
        }
      }
      this.$emit('addFile', {
        tempPath: this.fileTemp.path,
        filename: this.filename,
        extension: this.extension,
        folder: this.selectedFolder,
        sharedWith: { users: usersWithRights, roles: rolesWithRights },
      });
    },

    displaySuggestionsFoldersList(state) {
      this.isFoldersListDisplayed = state;
      if (state) {
        this.searchFolder = '';
        this.currentFolderInFolderSelection = null;
      }
    },

    selectFolder(folder) {
      this.selectedFolder = folder.id;
      this.searchFolder = folder.name;
      this.displaySuggestionsFoldersList(false);
    },

    returnBack() {
      this.currentFolderInFolderSelection = this.folders.filter(
        (f) => f.id == this.currentFolderInFolderSelection
      )[0].folder_id;
    },

    memberHasAccessToDepotDoc(member) {
      const isDepotDoc = (permission) =>
        permission.name == Constants.PERMISSION_DEPOT_DOCUMENTS_PAGE;
      const hasDepotDoc = (role) => role.permissions.some(isDepotDoc);
      return member.roles.some(hasDepotDoc);
    },

    roleHasAccessToDepotDoc(role) {
      const isDepotDoc = (permission) =>
        permission.name == Constants.PERMISSION_DEPOT_DOCUMENTS_PAGE;
      return role.permissions.some(isDepotDoc);
    },

    memberIsBeneficiary(member) {
      const isBeneficiary = (role) =>
        role.display_name == Constants.ROLE_BENEFICIAIRE;
      return member.roles.some(isBeneficiary);
    },

    mainRole(member) {
      if (this.memberIsBeneficiary(member)) {
        return member.roles.filter(
          (role) => role.display_name == Constants.ROLE_BENEFICIAIRE
        )[0];
      }
      if (member.roles.filter((role) => role.company_id !== null).length == 0) {
        return member.roles[0];
      }
      return member.roles.filter((role) => role.company_id !== null)[0];
    },
  },
};
</script>
